import { type FC } from 'react';


import { type IconProps } from './types';

export const ArrowsIntegration1V4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M65 35H35V65" stroke="#FFDD00" strokeWidth="2" />
      <path d="M1 31V1H31" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};
